// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"112":"component---src-pages-all-tsx","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"112":"b52e1f0d38cf61c3a625","245":"5e0d21080ef2438d710e"}[chunkId] + ".js";
};